(ns common.schema.entities.vault.vault-usage
  (:require [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def usage-types
  [{:key   :vault-usage.type/login
    :label "Login"}
   {:key   :vault-usage.type/download
    :label "Download"}
   {:key   :vault-usage.type/view
    :label "View"}])

(def schema
  (concat
   (su/keyword-field :vault-usage/type
                     "Usage type"
                     usage-types
                     (system-controlled {:authorization su/access-system-user}))
   (su/email-field :vault-usage/email
                   "Email"
                   (system-controlled {:authorization su/access-system-user}))
   (su/text-simple-field :vault-usage/filename
                         "Filename"
                         (system-controlled {:authorization su/access-system-user}))
   (su/single-ref-field :vault-usage/vault
                        "Vault"
                        [:entity.type/zap-vault]
                        (system-controlled {:authorization su/access-system-user}))))
